const Icons = {
  check: 'e900',
  checks: 'e901',
  activesessions: 'e902',
  add: 'e903',
  add_chat: 'e904',
  add_reaction: 'e905',
  addboost: 'e906',
  addmember_filled: 'e907',
  adduser: 'e908',
  admin: 'e909',
  ads: 'e90a',
  align_center: 'e90b',
  align_left: 'e90c',
  align_right: 'e90d',
  animals: 'e90e',
  animations: 'e90f',
  app_expand: 'e910',
  app_shrink: 'e911',
  archive: 'e912',
  archive_filled: 'e913',
  arrow_down: 'e914',
  arrow_next: 'e915',
  arrow_prev: 'e916',
  arrow_up_circle_fill: 'e917',
  arrowcircle: 'e918',
  arrowhead: 'e919',
  attach: 'e91a',
  attach_edit: 'e91b',
  audio_repeat: 'e91c',
  audio_repeat_single: 'e91d',
  author_hidden: 'e91e',
  auto_delete_circle_1: 'e91f',
  auto_delete_circle_2: 'e920',
  auto_delete_circle_3: 'e921',
  auto_delete_circle_4: 'e922',
  auto_delete_circle_5: 'e923',
  auto_delete_circle_6: 'e924',
  auto_delete_circle_7: 'e925',
  auto_delete_circle_8: 'e926',
  auto_delete_circle_clock: 'e927',
  auto_delete_circle_days: 'e928',
  auto_delete_circle_empty: 'e929',
  auto_delete_circle_hours: 'e92a',
  auto_delete_circle_months: 'e92b',
  auto_delete_circle_off: 'e92c',
  auto_delete_circle_weeks: 'e92d',
  auto_delete_circle_years: 'e92e',
  avatarnext: 'e92f',
  avatarprevious: 'e930',
  aversion: 'e931',
  back: 'e932',
  backward_5: 'e933',
  binfilled: 'e934',
  bold: 'e935',
  bomb: 'e936',
  boost: 'e937',
  boostcircle: 'e938',
  boosts: 'e939',
  bot_filled: 'e93a',
  botcom: 'e93b',
  bots: 'e93c',
  brightness: 'e93d',
  brush: 'e93e',
  bubblereply: 'e93f',
  bug: 'e940',
  calendar: 'e941',
  calendarfilter: 'e942',
  camera: 'e943',
  cameraadd: 'e944',
  captiondown: 'e945',
  captionup: 'e946',
  car: 'e947',
  card: 'e948',
  card_outline: 'e949',
  cash_circle: 'e94a',
  channel: 'e94b',
  channel_filled: 'e94c',
  channelviews: 'e94d',
  chatspinned: 'e94e',
  chatsplaceholder: 'e94f',
  check1: 'e950',
  checkbox: 'e951',
  checkboxblock: 'e952',
  checkboxempty: 'e953',
  checkboxon: 'e954',
  checklist_add: 'e955',
  checklist_done: 'e956',
  checklist_undone: 'e957',
  checkretract: 'e958',
  checkround: 'e959',
  checkround_filled: 'e95a',
  clipboard: 'e95b',
  clock: 'e95c',
  close: 'e95d',
  clouddownload: 'e95e',
  collapse: 'e95f',
  colorize: 'e960',
  comments: 'e961',
  commentssticker: 'e962',
  contrast: 'e963',
  copy: 'e964',
  crop: 'e965',
  cross: 'e966',
  crossgif: 'e967',
  crossround: 'e968',
  crossround_filled: 'e969',
  crossstar: 'e96a',
  crown: 'e96b',
  crown_outline: 'e96c',
  crownalt: 'e96d',
  crownoff: 'e96e',
  crownoff_outline: 'e96f',
  darkmode: 'e970',
  darkmode_filled: 'e971',
  data: 'e972',
  delete: 'e973',
  delete_filled: 'e974',
  deletedaccount: 'e975',
  deleteleft: 'e976',
  deleteuser: 'e977',
  devices: 'e978',
  document: 'e979',
  dollar_circle: 'e97a',
  dollar_circle_x: 'e97b',
  down: 'e97c',
  down_crossed: 'e97d',
  down_up: 'e97e',
  download: 'e97f',
  dragfiles: 'e980',
  dragmedia: 'e981',
  eats: 'e982',
  edit: 'e983',
  email: 'e984',
  endcall_filled: 'e985',
  enhance: 'e986',
  enter: 'e987',
  equalizer: 'e988',
  expand: 'e989',
  eye: 'e98a',
  eye1: 'e98b',
  eye2: 'e98c',
  eyecross_outline: 'e98d',
  faceid: 'e98e',
  factcheck: 'e98f',
  fade: 'e990',
  fast_forward: 'e991',
  fast_rewind: 'e992',
  favourites: 'e993',
  filter: 'e994',
  fire: 'e995',
  flag: 'e996',
  flip: 'e997',
  flip_image_horizontal: 'e998',
  folder: 'e999',
  fontframe: 'e99a',
  fontframe_bg: 'e99b',
  fontframe_outline: 'e99c',
  fontsize: 'e99d',
  forward: 'e99e',
  forward_25: 'e99f',
  forward_filled: 'e9a0',
  free_transform: 'e9a1',
  fullscreen: 'e9a2',
  gc_microphone: 'e9a3',
  gc_microphoneoff: 'e9a4',
  gem: 'e9a5',
  gem_exchange: 'e9a6',
  gem_transfer: 'e9a7',
  gem_transfer_outline: 'e9a8',
  geometric_digit_0: 'e9a9',
  geometric_digit_1: 'e9aa',
  geometric_digit_2: 'e9ab',
  geometric_digit_3: 'e9ac',
  geometric_digit_4: 'e9ad',
  geometric_digit_5: 'e9ae',
  geometric_digit_6: 'e9af',
  geometric_digit_7: 'e9b0',
  geometric_digit_8: 'e9b1',
  geometric_digit_9: 'e9b2',
  geometric_dot: 'e9b3',
  geometric_letter_x: 'e9b4',
  gifs: 'e9b5',
  gift: 'e9b6',
  gift_premium: 'e9b7',
  grain: 'e9b8',
  group: 'e9b9',
  group_filled: 'e9ba',
  group_star: 'e9bb',
  groupmedia: 'e9bc',
  groupmediaoff: 'e9bd',
  hand: 'e9be',
  help: 'e9bf',
  hide: 'e9c0',
  highlights: 'e9c1',
  hourglass: 'e9c2',
  image: 'e9c3',
  image_original: 'e9c4',
  info: 'e9c5',
  info2: 'e9c6',
  italic: 'e9c7',
  key: 'e9c8',
  keyboard: 'e9c9',
  lamp: 'e9ca',
  language: 'e9cb',
  largepause: 'e9cc',
  largeplay: 'e9cd',
  left: 'e9ce',
  limit_chat: 'e9cf',
  limit_chats: 'e9d0',
  limit_file: 'e9d1',
  limit_folders: 'e9d2',
  limit_link: 'e9d3',
  limit_pin: 'e9d4',
  link: 'e9d5',
  link_paid: 'e9d6',
  list: 'e9d7',
  listscreenshare: 'e9d8',
  livelocation: 'e9d9',
  livestream: 'e9da',
  location: 'e9db',
  lock: 'e9dc',
  lockoff: 'e9dd',
  loginlogodesktop: 'e9de',
  loginlogomobile: 'e9df',
  logo: 'e9e0',
  logout: 'e9e1',
  mac_command_key: 'e9e2',
  mediaspeed_empty: 'e9e3',
  mediaspoiler: 'e9e4',
  mediaspoileroff: 'e9e5',
  mention: 'e9e6',
  menu: 'e9e7',
  menu_feature_cover: 'e9e8',
  menu_feature_unique: 'e9e9',
  menu_verification: 'e9ea',
  message: 'e9eb',
  message_jump: 'e9ec',
  message_quote: 'e9ed',
  messageunread: 'e9ee',
  microphone: 'e9ef',
  microphone_crossed: 'e9f0',
  microphone_crossed_filled: 'e9f1',
  microphone_filled: 'e9f2',
  minus: 'e9f3',
  monospace: 'e9f4',
  more: 'e9f5',
  movetochats: 'e9f6',
  movetomenu: 'e9f7',
  multistories: 'e9f8',
  music: 'e9f9',
  mute: 'e9fa',
  muted: 'e9fb',
  mynotes: 'e9fc',
  newchannel: 'e9fd',
  newchannel_filled: 'e9fe',
  newchat_filled: 'e9ff',
  newgroup: 'ea00',
  newgroup_filled: 'ea01',
  newprivate: 'ea02',
  newprivate_filled: 'ea03',
  newtab: 'ea04',
  next: 'ea05',
  nochannel: 'ea06',
  noncontacts: 'ea07',
  nosound: 'ea08',
  note: 'ea09',
  okay: 'ea0a',
  online: 'ea0b',
  passwordoff: 'ea0c',
  pause: 'ea0d',
  permissions: 'ea0e',
  person: 'ea0f',
  phone: 'ea10',
  phone_filled: 'ea11',
  pin: 'ea12',
  pin2: 'ea13',
  pinlist: 'ea14',
  pinned_filled: 'ea15',
  pinnedchat: 'ea16',
  pinnedchat_filled: 'ea17',
  pip: 'ea18',
  play: 'ea19',
  playback_05: 'ea1a',
  playback_15: 'ea1b',
  playback_1x: 'ea1c',
  playback_2x: 'ea1d',
  plus: 'ea1e',
  plusround: 'ea1f',
  poll: 'ea20',
  poll_multiple_answers: 'ea21',
  premium_addone: 'ea22',
  premium_avatars: 'ea23',
  premium_badge: 'ea24',
  premium_colors: 'ea25',
  premium_double: 'ea26',
  premium_emoji: 'ea27',
  premium_filesize: 'ea28',
  premium_lastseen: 'ea29',
  premium_limits: 'ea2a',
  premium_lock: 'ea2b',
  premium_management: 'ea2c',
  premium_noads: 'ea2d',
  premium_privacy: 'ea2e',
  premium_reactions: 'ea2f',
  premium_restrict: 'ea30',
  premium_speed: 'ea31',
  premium_status: 'ea32',
  premium_stickers: 'ea33',
  premium_tags: 'ea34',
  premium_transcription: 'ea35',
  premium_translate: 'ea36',
  premium_unlock: 'ea37',
  premium_wallpaper: 'ea38',
  previous: 'ea39',
  privacypolicy: 'ea3a',
  promote: 'ea3b',
  qr: 'ea3c',
  quote: 'ea3d',
  quote_outline: 'ea3e',
  radiooff: 'ea3f',
  radioon: 'ea40',
  reactions: 'ea41',
  reactions_filled: 'ea42',
  readchats: 'ea43',
  recent: 'ea44',
  recordround: 'ea45',
  redo: 'ea46',
  reload_star: 'ea47',
  replace: 'ea48',
  reply: 'ea49',
  reply_filled: 'ea4a',
  restrict: 'ea4b',
  revenue: 'ea4c',
  rightpanel: 'ea4d',
  rotate: 'ea4e',
  rotate_left: 'ea4f',
  rotate_right: 'ea50',
  round_chats_filled: 'ea51',
  saturation: 'ea52',
  saved: 'ea53',
  savedmessages: 'ea54',
  schedule: 'ea55',
  scheduled: 'ea56',
  screen_crossed: 'ea57',
  search: 'ea58',
  select: 'ea59',
  send: 'ea5a',
  send2: 'ea5b',
  sending: 'ea5c',
  sendingerror: 'ea5d',
  settings: 'ea5e',
  settings_clipped_corner: 'ea5f',
  settings_filled: 'ea60',
  shadows: 'ea61',
  sharescreen_filled: 'ea62',
  sharingoff: 'ea63',
  sharingoff_filled: 'ea64',
  sharingon: 'ea65',
  sharpen: 'ea66',
  shipping: 'ea67',
  shuffle: 'ea68',
  smallscreen: 'ea69',
  smile: 'ea6a',
  sort_date: 'ea6b',
  sort_num: 'ea6c',
  sort_price: 'ea6d',
  speaker: 'ea6e',
  speakerfilled: 'ea6f',
  speakeroff: 'ea70',
  speakerofffilled: 'ea71',
  spoiler: 'ea72',
  sport: 'ea73',
  star: 'ea74',
  star_filled: 'ea75',
  statistics: 'ea76',
  stickers: 'ea77',
  stickers_face: 'ea78',
  stop: 'ea79',
  stories: 'ea7a',
  story: 'ea7b',
  storyreply: 'ea7c',
  storyrepost: 'ea7d',
  strikethrough: 'ea7e',
  suggested: 'ea7f',
  tag: 'ea80',
  tag_add: 'ea81',
  tag_alt: 'ea82',
  tag_alt_crossed: 'ea83',
  tag_alt_outline: 'ea84',
  tag_crossed: 'ea85',
  tag_filter: 'ea86',
  tag_name: 'ea87',
  text: 'ea88',
  textedit: 'ea89',
  time_lock: 'ea8a',
  timer: 'ea8b',
  tip: 'ea8c',
  ton: 'ea8d',
  tools: 'ea8e',
  topics: 'ea8f',
  trade: 'ea90',
  transcribe: 'ea91',
  unarchive: 'ea92',
  unclaimed: 'ea93',
  underline: 'ea94',
  undo: 'ea95',
  unmute: 'ea96',
  unpack: 'ea97',
  unpin: 'ea98',
  unread: 'ea99',
  up: 'ea9a',
  up_down: 'ea9b',
  user: 'ea9c',
  username: 'ea9d',
  videocamera: 'ea9e',
  videocamera_crossed_filled: 'ea9f',
  videocamera_filled: 'eaa0',
  videochat: 'eaa1',
  vignette: 'eaa2',
  volume_down: 'eaa3',
  volume_mute: 'eaa4',
  volume_off: 'eaa5',
  volume_up: 'eaa6',
  warmth: 'eaa7',
  warning: 'eaa8',
  webview: 'eaa9',
  win_key: 'eaaa',
  zoomin: 'eaab',
  zoomout: 'eaac'
};

export default Icons;
